<template>
  <div style="width:100%;height:100%;z-index: 10000;">
    <button style="width:100%;height:100%;cursor: pointer;" :style="{width:width,heigth:height,fontSize:fontSize,fontFamily:chartConfig.fontFamily,color:chartConfig.color,
    textAlign:align,verticalAlign:valign,letterSpacing:letterSpacing,fontWeight:chartConfig.fontWeight,background:chartConfig.background,
    borderLeft:chartConfig.borderLeft,borderRight:chartConfig.borderRight,borderBottom:chartConfig.borderBottom,borderTop:chartConfig.borderTop}"
      v-if="checkBtn()" @click="titleClick">{{chartConfig.title}}</button>
  </div>
</template>


<style>
</style>
<script>
  import fwUtil from 'framework-util'
  import {
    getDataService,
    postDataService
  } from '../../../api/chart/chart/index.js'
  export default {
    props: {
      width: {
        type: String,
        default: '300px'
      },
      height: {
        type: String,
        default: '30px'
      },
      queryConfig: {
        type: Object,
        default () {
          return {
            checkUrl: null,
            submitUrl: null,
            params: []
          }
        }

      },
      chartConfig: {
        type: Object,
        default: function() {
          return {
            fontSize: 24,
            fontFamily: '微软雅黑',
            name: '标准标题',
            title: '标准标题',
            color: '#fff',
            background: 'rgba(0,0,0,0)',
            align: 'center',
            verticalAlign: 'middle',
            letterSpacing: 8,
            fontWeight: 'normal',
            border: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            borderTop: 'none',
            borderBottom: 'none',
            btnType: '',
            isBtnDefShow: false
          }
        }
      }
    },
    watch: {
      queryConfig: {
        handler(newValue, oldValue) {
          this.checkBtnState()
        },
        deep: true
      }
    },
    computed: {


      letterSpacing() {
        return this.chartConfig.letterSpacing + "px"
      },
      fontSize() {
        return this.chartConfig.fontSize + "px"
      },
      align() {
        if (!this.chartConfig.align) {
          return 'left'
        }
        return this.chartConfig.align
      },
      valign() {
        if (!this.chartConfig.verticalAlign) {
          return 'middle'
        }
        return this.chartConfig.verticalAlign
      }
    },
    data() {
      return {
        timer: null
      }
    },
    mounted() {
      this.checkBtnState()
      let that = this
      this.timer = setInterval(function() {
        that.checkBtnState()
      }, 1000 * 30)
    },
    beforeDestroy() {
      if (this.timer != null) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    methods: {
      checkBtn() {
        console.info("===this.chartConfig.isBtnDefShow==" + this.chartConfig.isBtnDefShow)
        return this.chartConfig.isBtnDefShow
      },
      getParams() {
        let params = {}
        if (this.queryConfig.params) {
          for (let i = 0; i < this.queryConfig.params.length; i++) {
            if (this.queryConfig.params[i].target &&
              this.queryConfig.params[i].source) {
              let _value = fwUtil.Helper.GetQueryString(this.queryConfig.params[i].source)
              if (_value) {
                params[this.queryConfig.params[i].target] = _value
              }
            }
            if (this.queryConfig.params[i].target &&
              !this.queryConfig.params[i].source) {
              let _value = this.queryConfig.parms[i].defaultValue
              if (_value) {
                params[this.queryConfig.params[i].target] = _value
              }
            }
          }
        }
        return params
      },
      checkBtnState() {
        let that = this
        if (this.queryConfig && this.queryConfig.checkUrl) {
          let url = this.queryConfig.checkUrl
          let params = this.getParams()
          getDataService(url, params).then((res) => {
            console.error("btn state===" + res)
            //that.$set(that.chartConfig, 'isBtnDefShow', this.res)
          })
        } else {
          console.error("btn state2===true")
          //that.$set(that.chartConfig, 'isBtnDefShow', true)
        }
      },
      titleClick() {
        let that = this
        console.info("this.queryConfig.submitUrl===" + this.queryConfig.submitUrl)
        if (this.chartConfig.btnType === 'go') {
          if (this.queryConfig.submitUrl) {
            window.location.href = this.chartConfig.submitUrl
          }
        } else {
          if (this.queryConfig.submitUrl) {
            let params = this.getParams()
            if (this.chartConfig.submitMessage) {
              this.$confirm(this.chartConfig.submitMessage, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                postDataService(this.queryConfig.submitUrl, params).then((res) => {
                  that.checkBtnState()
                })
              })
            } else {
              postDataService(this.queryConfig.submitUrl, params).then((res) => {
                that.checkBtnState()
              })
            }

          }
        }

      }
    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/text/components/buttonComponents.vue